var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.294,
    height: 50.294,
    viewBox: "0 0 50.294 50.294",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: #004057;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke: #1d384d;\r\n        stroke-width: 0.294px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons-14",
    transform: "translate(-3.209 -2.534)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7635",
    "data-name": "Path 7635",
    className: "cls-1",
    d: "M27.47,8.04A2.931,2.931,0,1,0,30.4,10.971,2.93,2.93,0,0,0,27.47,8.04Z",
    transform: "translate(14.122 3.572)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7636",
    "data-name": "Path 7636",
    className: "cls-1",
    d: "M23.4,10.295A12.313,12.313,0,1,0,35.716,22.607,12.329,12.329,0,0,0,23.4,10.295Zm0,20.2a7.889,7.889,0,1,1,7.889-7.889A7.9,7.9,0,0,1,23.4,30.5Z",
    transform: "translate(5.156 5.076)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7637",
    "data-name": "Path 7637",
    className: "cls-2",
    d: "M38.337,52.681H18.375A15.038,15.038,0,0,1,3.356,37.662V17.7A15.038,15.038,0,0,1,18.375,2.681H38.337A15.038,15.038,0,0,1,53.356,17.7V37.662A15.038,15.038,0,0,1,38.337,52.681ZM18.375,7.389A10.327,10.327,0,0,0,8.059,17.7V37.667A10.327,10.327,0,0,0,18.375,47.983H38.337A10.327,10.327,0,0,0,48.653,37.667V17.7A10.33,10.33,0,0,0,38.337,7.389H18.375Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.43a90a20ed4e57035550af18c894405a.svg";
export { ForwardRef as ReactComponent };